import React, { useEffect, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Grid, TextField, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { toast } from 'react-toastify';
import ORBApi from '../../../../services/ORBApi';
import CpfCnpj from '../../../../components/common/CpfCnpj';
import Loading from '../../../../components/common/Loading';

const RegisterContributors = (props) => {
  const [contributor, setContributor] = useState({
    name: '',
    artist_name: '',
    document: '',
  });

  useEffect(() => {}, []);

  return (
    <div>
      <h4>Titulares nao cadastrados</h4>
      <hr />
      <TableContainer
        component={Paper}
        style={{ marginBottom: '30px', maxHeight: '250px' }}
      >
        <Table
          sx={{
            height: 'max-content',
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell align="center">Nome</TableCell>
              <TableCell align="center">Documento</TableCell>
              <TableCell align="center"> </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.contributorsData.map((contributor) => {
              return (
                <TableRow
                  key={contributor.name}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell align="center" component="th" scope="row">
                    {contributor.name}
                  </TableCell>
                  <TableCell align="center" component="th" scope="row">
                    {contributor.document}
                  </TableCell>
                  <TableCell align="center">
                    <AddIcon
                      className="clickable"
                      color="secondary"
                      onClick={() => {
                        setContributor({
                          name: contributor.name,
                          document: contributor.document,
                        });
                        props.setContributorsData(
                          props.contributorsData.filter(
                            (item) => item.id !== contributor.id,
                          ),
                        );
                      }}
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <ContributorForm
        contributor={contributor}
        setContributor={setContributor}
      />
    </div>
  );
};

function ContributorForm(props) {
  const title = '';
  const [isSaving, setIsSaving] = useState(false);

  const saveContributor = () => {
    if (props.contributor.name === '') {
      toast.warn('Por favor, preencha todos os dados!');
      return;
    }
    setIsSaving(true);
    ORBApi.postContributors(props.contributor)
      .then(() => {
        toast.success('Titular Salvo!');
        props.setContributor({ name: '', artist_name: '', document: '' });
      })
      .catch(() => {
        toast.error('Falha ao salvar Titular.');
      })
      .finally(() => {
        setIsSaving(false);
      });
  };
  return (
    <>
      <h4>{title}</h4>
      <hr />
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={6}>
          <TextField
            label="Nome"
            variant="outlined"
            fullWidth
            value={props.contributor.name}
            onChange={(e) =>
              props.setContributor({
                ...props.contributor,
                name: e.target.value.toUpperCase(),
              })
            }
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Nome Artistico"
            variant="outlined"
            fullWidth
            value={props.contributor.artist_name}
            onChange={(e) =>
              props.setContributor({
                ...props.contributor,
                artist_name: e.target.value.toUpperCase(),
              })
            }
          />
        </Grid>
        <Grid item xs={6}>
          <CpfCnpj
            value={props.contributor.document}
            onChange={(e) =>
              props.setContributor({
                ...props.contributor,
                document: e.target.value.replace(/\D/g, ''),
              })
            }
          />
        </Grid>
      </Grid>
      <Grid item xs={6} style={{ marginTop: '15px' }}>
        {!isSaving ? (
          <Button
            variant="contained"
            color="secondary"
            size="large"
            onClick={saveContributor}
          >
            {' '}
            Salvar{' '}
          </Button>
        ) : (
          <Loading />
        )}
      </Grid>
    </>
  );
}

export default RegisterContributors;
